/**
 * Common values and methods for form validation
 *
 * @author Hayden Eastwell
 */
export class ValidationUtils {

    static DEALER_NO_PATTERN = /^[a-zA-Z0-9/]+$/
    static EMAIL_PATTERN = /^([\w\-._]+)([+]?)([\w\-.]+)@(([0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)([ ]*)$/
    static ID_PATTERN = /^[a-zA-Z0-9-_]*$/
    static NAME_PATTERN = /^[a-zA-Z0-9-_:' ]*$/
    static NUMBER_ONLY_PATTERN = /^[0-9]*$/
    static PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])(?=.{14,})/
    static PHONE_PATTERN = /^[0-9\-_+ ]*$/
    static SUB_ID_PATTERN = /^[a-zA-Z0-9]*$/
    static TITLE_PATTERN = /^[a-zA-Z0-9\-_:()[\]./& ]*$/
}
